import { app } from '../../../app';

app.component('requestCenter', {
    bindings: {
        requests: '<',
        companyId: '<',
    },
    templateUrl: require('./request-center.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/request-center/request-center.component.js